import { createSlice } from "@reduxjs/toolkit";

interface pageNumberss {
  pageNumbers: number;
  fixedPageNumbers: number;
  pageSize?: number;
}

const initialState: pageNumberss = {
  pageNumbers: 1,
  fixedPageNumbers: 1,
  pageSize: 10,
};

const pageNumber = createSlice({
  initialState,
  name: "pageNumber",
  reducers: {
    Actionpage: (state, action) => {
      state.pageNumbers = action.payload;
      state.fixedPageNumbers = action.payload;
    },
    ActionpageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    clearPaginate: (state, action) => {
      state.pageNumbers = action.payload;
    },
    // ActionFixedpage:(state,action)=>{
    //     state.fixedPageNumbers=action.payload
    // },
    clearFixedPaginate: (state) => {
      state.fixedPageNumbers = 1;
    },
  },
});

export const { Actionpage, clearPaginate, clearFixedPaginate,ActionpageSize } =
  pageNumber.actions;
export default pageNumber.reducer;
